import { render, staticRenderFns } from "./SectionFAQ.vue?vue&type=template&id=452b7a5d&"
import script from "./SectionFAQ.vue?vue&type=script&lang=js&"
export * from "./SectionFAQ.vue?vue&type=script&lang=js&"
import style0 from "./SectionFAQ.vue?vue&type=style&index=0&id=452b7a5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
